export default "__VITE_ASSET__CbdKKJwi__"